import { render, staticRenderFns } from "./SinisterInspection.vue?vue&type=template&id=6781bb4e&scoped=true"
import script from "./SinisterInspection.vue?vue&type=script&lang=ts"
export * from "./SinisterInspection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781bb4e",
  null
  
)

export default component.exports